import { Link, useNavigate } from '@tanstack/react-location'
import { getLivingLinks, getPropertyLivingLinks } from 'MediaManager/services/links'
import React, { useCallback, useMemo } from 'react'
import Button from 'shared/components/Button'
import DataTable from 'shared/components/DataTable'
import Loader from 'shared/components/Loader'
import { useRequest } from 'shared/hooks/useRequest'
import { ReactComponent as EditIcon } from './icons/edit.svg'
function LivingLinks({ property }) {
  const getLivingLinksRequest = useCallback(async () => {
    const { data } = await getPropertyLivingLinks(property.property_name)
    return data.long_short_links_by_property_name
  }, [property])

  const { data: links, loading } = useRequest(getLivingLinksRequest)

  const table = [
    {
      label: 'Short URL',
      data: (d) => (
        <a target="_blank" rel="noreferrer" href={d.link_short} onClick={(e) => e.stopPropagation()}>
          <span className="truncate inline-block w-[100%]">{d.link_short || '-'}</span>
        </a>
      ),
    },
    {
      label: 'Description',
      data: (d) => d.description || '-',
    },
    {
      label: 'Unit ID',
      data: (d) => d.configuration.sightmap?.unit_id || '-',
    },
    {
      label: 'Unit Number',
      data: (d) => d.configuration.sightmap?.unit_number || '-',
    },
    {
      label: 'Unit Type ID',
      data: (d) => d.configuration.unit_type_id || '-',
    },
    {
      label: '',
      data: (d) => (
        <div className="flex justify-end">
          <Link to={`/living/links/edit?id=${d.id}`}>
            <EditIcon />
          </Link>
        </div>
      ),
    },
  ]

  const sightmapTable = [
    {
      label: 'ID',
      data: (d) => d.id,
    },
    {
      label: 'Asset ID',
      data: (d) => d.configuration.sightmap?.asset_id || '-',
    },
    {
      label: 'Outbound Link ID',
      data: (d) => d.configuration.sightmap?.asset_id || '-',
    },
    {
      label: 'SparX Living Short URL',
      data: (d) => (
        <a target="_blank" rel="noreferrer" href={d.link_short} onClick={(e) => e.stopPropagation()}>
          <span className="truncate inline-block w-[100%]">{d.link_short || '-'}</span>
        </a>
      ),
    },
    {
      label: 'Unit ID',
      data: (d) => d.configuration.sightmap?.unit_id || '-',
    },
    {
      label: 'Unit Number',
      data: (d) => d.configuration.sightmap?.unit_number || '-',
    },
    {
      label: 'Unit Type ID',
      data: (d) => d.configuration.unit_type_id || '-',
    },
    {
      label: '',
      data: (d) => (
        <div className="flex justify-end">
          <Link to={`/living/links/edit?id=${d.id}`}>
            <EditIcon />
          </Link>
        </div>
      ),
    },
  ]

  const navigate = useNavigate()

  const actions = [
    {
      label: 'Create new link',
      action: () => {
        navigate({ to: `/living/links/create?property_id=${property.id}` })
      },
    },
  ]

  const sightmapLinks = useMemo(() => {
    if (!links) return []
    return links.filter((link) => link.provider === 'sightmap')
  }, [links])

  const sightmapActions = [
    {
      label: 'Create sightmap link',
      action: () => {
        navigate({ to: `/living/links/create?property_id=${property.id}` })
      },
    },
  ]

  return (
    <>
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      {!loading && (
        <div>
          <DataTable
            title="SparX Living Links"
            onRowClick={(r) => navigate({ to: `/living/links/edit?id=${r.id}` })}
            data={links}
            structure={table}
            actions={actions}
          />
          <DataTable
            title="SightMap Links"
            onRowClick={(r) => navigate({ to: `/living/links/create` })}
            data={sightmapLinks}
            structure={sightmapTable}
            actions={sightmapActions}
          />
        </div>
      )}
    </>
  )
}

export default LivingLinks
